const makeToast = {
  methods: {
    makeToast(
      title = 'Aviso',
      message,
      variant = 'success',
      position = 'b-toaster-top-right',
      time=5000
    ) {
      this.$bvToast.toast(message, {
        title,
        variant,
        toaster: position,
        autoHideDelay: time,
        appendToast: true,
      });
    },
  },
};

export default makeToast;
